import { Routes, Route } from 'react-router-dom';
import { ProtectedRoute } from './components/ProtectedRoute.jsx';
import DashboardPage from './pages/Dashboard.jsx';
import MetricasPage from './pages/Metricas.jsx';
import MetricasDesempenhoPage from './pages/MetricasDesempenho.jsx';
import ColaboradoresPage from './pages/Colaboradores.jsx';
import RelatoriosPage from './pages/Relatorios.jsx';
import FechamentoPage from './pages/Fechamento.jsx';
import NotFoundPage from './pages/NotFound.jsx';
import UsuariosPage from './pages/Usuarios.jsx';

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
      <Route path="/metricas" element={<ProtectedRoute roles={["COLABORADOR","LIDER","RH","GERENTE"]}><MetricasPage /></ProtectedRoute>} />
      <Route path="/metricas/gerenciar-metricas" element={<ProtectedRoute roles={["RH","GERENTE"]}><MetricasDesempenhoPage /></ProtectedRoute>} />
      <Route path="/colaboradores" element={<ProtectedRoute roles={["LIDER","RH","GERENTE"]}><ColaboradoresPage /></ProtectedRoute>} />
      <Route path="/relatorios" element={<ProtectedRoute roles={["COLABORADOR","LIDER","RH","GERENTE"]}><RelatoriosPage /></ProtectedRoute>} />
      <Route path="/fechamento" element={<ProtectedRoute roles={["RH","GERENTE"]}><FechamentoPage /></ProtectedRoute>} />
  <Route path="/usuarios" element={<ProtectedRoute roles={["RH","GERENTE"]}><UsuariosPage /></ProtectedRoute>} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
